import React, { useMemo } from 'react';
import { Dialog } from 'components/Dialog';
import Stepper from 'components/Stepper';
import DisplayText from 'components/ui-kits/DisplayText';

type UnsubscribePlanDialogProps = {
  renewalDate: string;
  onClose: () => void;
  onConfirm: (args?: any) => void;
};

const UnsubscribePlanDialog = ({
  onClose,
  onConfirm,
  renewalDate
}: UnsubscribePlanDialogProps) => {
  const step: React.ComponentPropsWithoutRef<typeof Stepper>['steps'] = useMemo(
    () => [
      {
        id: 'unsubscribePlan',
        header: 'Désabonnez-vous',
        headerButtonConfig: {
          closeButton: {
            onClick: onClose
          }
        },
        footerConfig: {
          previousButton: {
            label: 'Annuler',
            onClick: onClose
          },
          nextButton: {
            label: 'Confirmer',
            onClick: onConfirm
          }
        },
        content: (
          <>
            <DisplayText fontSize="L" color="BLACK_6">
              Vous êtes sur le point de résilier votre abonnement à la formule
              STANDARD.
            </DisplayText>
            <DisplayText fontSize="L" color="BLACK_6" margin="2rem 0">
              En conséquence, l&lsquo;accès aux fonctionnalités incluses dans
              cette formule — notamment le rapport des ventes et le tarif
              préférentiel sur les frais de transaction (si le paiement en ligne
              est activé) — sera interrompu.
            </DisplayText>
            <DisplayText fontSize="L" color="BLACK_6" margin="2rem 0">
              En confirmant, votre accès à la formule STANDARD sera maintenu
              jusqu&lsquo;au <strong>{renewalDate}</strong>, puis
              automatiquement stoppé à cette date.
            </DisplayText>
            <DisplayText fontSize="L" color="BLACK_6" margin="0 0 3rem 0">
              Confirmez-vous votre désabonnement ?
            </DisplayText>
          </>
        )
      }
    ],
    [renewalDate, onClose, onConfirm]
  );

  return (
    <Dialog showOverlay maxWidth="50rem">
      <Stepper steps={step} />
    </Dialog>
  );
};

export default UnsubscribePlanDialog;
